import React from 'react';
import PropTypes from 'prop-types';

import { Modal, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

import './styles.scss';

const QuokkaTemplateDefaultsModal = ({ iframeData, open, onClose, refreshQuokkaData }) => {
  return (
    <Modal
      dialogClassName="w-100 h-100"
      show={open}
      onEnter={() => refreshQuokkaData('sale')}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Edit Template Default Options

          <div className="property-type-toggle d-flex align-items-center my-2">
            <h4> Property Type: </h4>
            <ToggleButtonGroup
              className="mx-2"
              defaultValue={'sale'}
              name="pluginListingTypeSelect"
              type="radio"
              onChange={e => e.preventDefault()}
            >
              <ToggleButton
                className={`property-type-toggle-button`}
                id="plugin-sale"
                value={'sale'}
                variant={'primary'}
                onClick={() => refreshQuokkaData('sale')}
              >
                Sale
              </ToggleButton>
              <ToggleButton
                className={`property-type-toggle-button`}
                id="plugin-lease"
                value={'lease'}
                variant={'primary'}
                onClick={() => refreshQuokkaData('lease')}
              >
                Lease
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body id="default-options-modal-editor">
        {
          iframeData ? (
            <iframe className="border w-100"
              ref={iframeData.ref}
              src={iframeData.src}
              style={{ height: '85vh' }}
            ></iframe>
          ) : (
            // Note: This should never happen
            <h3 className="d-flex justify-content-center align-items-center" style={{ height: '85vh' }}>
              Before editing options, please publish a property on the Website Editor.
            </h3>
          )
        }
      </Modal.Body>
    </Modal>
  );
};

QuokkaTemplateDefaultsModal.propTypes = {
  iframeData: PropTypes.shape({
    src: PropTypes.string.isRequired,
    ref: PropTypes.object.isRequired
  }),
  open: PropTypes.bool.isRequired,
  refreshQuokkaData: PropTypes.func,
  onClose: PropTypes.func
};

export default QuokkaTemplateDefaultsModal;
